






import {Prop, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {Widget} from "@/components/dashboard/Dashboard.vue";
import _, {forEach} from "lodash";

interface Style {
    [property: string]: string | number;
}

const components = {};
@Component({ components })

export default class Container extends Vue {
    @Prop({ default: null }) public widget!: Widget;
    @Prop({ type: Object, default: () => ({}) }) public defaultStyle!: Style;


    public get containerStyle(): Style {
        const style: Style = {
            padding: "10px",
            ...this.defaultStyle,
        };

        if (_.has(this.widget, "area")) {
            _.set(style, "grid-area", this.widget.area);
        }

        forEach(_.get(this.widget, "parameters.style", {}), (value: string|number, key: string) => {
            _.set(style, key, value);
        });

        return style;
    }
}
